export default __webpack_public_path__ + "static/media/closet5-after3-2048w.b4e1f0e5.avif";